<template>
  <div class="cards">
    <div class="card-frame">
      <div class="frame-wrapper">
        <iframe
            v-if="cardUrl"
            :src="cardUrl"
            width="100%"
            height="600"
            frameborder="0"
            allowfullscreen
            @load="onFrameLoad"
        ></iframe>

        <div v-if="isLoading" class="loader-overlay">
          <base-loader></base-loader>
        </div>
      </div>

      <div v-if="!isLoading && cardUrl" class="prompt">
        <span>{{ $t('user.user_card.prompt') }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { TokenizationApi } from "@/office/tokenization/tokenization-api";
import BaseLoader from "@/components/base/BaseLoader.vue";
import { mapGetters } from "vuex";

export default {
  name: "Cards",
  data() {
    return {
      cardUrl: null,
      isLoading: true,
    };
  },

  components: {
    BaseLoader,
  },

  created() {
    this.getOwnCards();
  },

  computed: {
    ...mapGetters(["currentLanguage"]),
  },

  methods: {
    async getOwnCards() {
      this.isLoading = true;
      try {
        const response = await new TokenizationApi().getCards(
            this.currentLanguage
        );

        if (response?.data?.cards?.url) {
          this.cardUrl = response.data.cards.url;
          // this.cardUrl = response.data.cards.url.replace(
          //     "https://stage-mapi.xpay.com.ua",
          //     "http://localhost:8002"
          // );
        }
      } catch (error) {
        console.error("Error fetching cards:", error);
        this.isLoading = false;
      }
    },
    onFrameLoad() {
      this.isLoading = false;
    },
  },

  watch: {
    currentLanguage() {
      this.getOwnCards();
    },
  }
};
</script>

<style lang="scss" scoped>
.frame-wrapper {
  position: relative;
  width: 100%;
  height: 600px;
}

.loader-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10;
}

.prompt {
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;

  span {
    font-size: 14px;
    font-weight: 500;
    color: #B9C4D8;
  }
}
</style>
